import { roundValue } from "lib/number";
import { MetricsKind } from "../types";
import { MergedColumnFormulaOptions } from "./types";
import { ValueGetterParams } from "ag-grid-community";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { getChildrenTotalRetail, getGrandTotalRetail } from "./total-retail";

export const DOOR_PERCENTAGE_PLAN = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const retailValue = referenceMetricValueOrCompute(
        () => getChildrenTotalRetail(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.TOTAL_RETAIL
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (!retailValue) {
        return 0;
    }

    // For grand total, this will always be 100
    if (retailValue > 0 && gridGetterParams.column.getColDef().type === ColumnTypes.AllDimensionTotal) {
        return 100;
    }

    // Get aggregrated total retail of a node group across all deliveries and groups
    const totalRetail = getGrandTotalRetail(options, gridGetterParams);

    return totalRetail > 0 ? roundValue((retailValue / totalRetail) * 100, options.decimal) : 0;
};
